import React, { useState, useEffect } from 'react';
import DashboardHeaderCard from '@/components/common/DashboardHeaderCard';
import { Package, CheckCircle, XCircle } from 'lucide-react';
import productService from '@/services/productService';

const ProductsManagementHeader = ({ products = [] }) => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    activeProducts: 0,
    inactiveProducts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductStats = async () => {
      try {
        setLoading(true);

        const allProductsData = await productService.getAllProducts();
        
        let allProducts = [];
        if (allProductsData && typeof allProductsData === 'object' && Array.isArray(allProductsData.data)) {
          allProducts = allProductsData.data;
        } else if (Array.isArray(allProductsData)) {
          allProducts = allProductsData;
        } else if (allProductsData && typeof allProductsData === 'object' && Array.isArray(allProductsData.products)) {
          allProducts = allProductsData.products;
        }
 
        const totalProducts = allProducts.length;
        const activeProducts = allProducts.filter(product => product.is_active).length;
        const inactiveProducts = totalProducts - activeProducts;
        
        setStats({
          totalProducts,
          activeProducts,
          inactiveProducts
        });
      } catch (error) {
        console.error("Failed to fetch product statistics:", error);
       
        const totalProducts = products.length;
        const activeProducts = products.filter(product => product.status === 'Active').length;
        const inactiveProducts = totalProducts - activeProducts;
        
        setStats({
          totalProducts,
          activeProducts,
          inactiveProducts
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProductStats();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full mb-6">
        <DashboardHeaderCard
          name="TOTAL PRODUCTS"
          count="0"
          icon={<Package size={18} color="hsl(var(--primary))" />}
          differenceText="All products"
        />

        <DashboardHeaderCard
          name="ACTIVE PRODUCTS"
          count="0"
          icon={<CheckCircle size={18} color="hsl(var(--primary))" />}
          differenceText="Currently available"
        />

        <DashboardHeaderCard
          name="INACTIVE PRODUCTS"
          count="0"
          icon={<XCircle size={18} color="hsl(var(--primary))" />}
          differenceText="Not in use"
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full mb-6">
      <DashboardHeaderCard
        name="TOTAL PRODUCTS"
        count={stats.totalProducts.toString()}
        icon={<Package size={18} color="hsl(var(--primary))" />}
        differenceText="All products"
      />

      <DashboardHeaderCard
        name="ACTIVE PRODUCTS"
        count={stats.activeProducts.toString()}
        icon={<CheckCircle size={18} color="hsl(var(--primary))" />}
        differenceText="Currently available"
      />

      <DashboardHeaderCard
        name="INACTIVE PRODUCTS"
        count={stats.inactiveProducts.toString()}
        icon={<XCircle size={18} color="hsl(var(--primary))" />}
        differenceText="Not in use"
      />
    </div>
  );
};

export default ProductsManagementHeader;